import React from 'react'

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion'
import { Card } from '@/components/ui/card'

import './index.css'

export default function API() {
  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold">Developer API</h1>

      <Card className="px-4">
        <Accordion type="single" collapsible defaultValue="getting-started">
          <AccordionItem value="getting-started">
            <AccordionTrigger>Getting Started</AccordionTrigger>
            <AccordionContent className="space-y-3 text-sm leading-relaxed text-muted-foreground">
              <p>
                Your Aberdeen Hub account gives you programmatic REST API access to query real-time updates on your
                orders and feed those updates to your servers for consumption. Our API infrastructure is built on
                Amazon Web Services and Salesforce, ensuring your data is protected and served securely.
              </p>
              <p>
                Aberdeen's engineering team can help your team implement API feeds. We also provide white-glove
                software development services on leading cloud providers to build your ideal system. For all API
                inquiries, email{' '}
                <a className="text-primary hover:underline" href="mailto:admin@aberdeen.io">admin@aberdeen.io</a>.
              </p>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="authentication" className="border-b-0">
            <AccordionTrigger>Authentication</AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground">Coming soon.</AccordionContent>
          </AccordionItem>
        </Accordion>
      </Card>
    </div>
  )
}
